import Type from "@/model/types/Type";

const type = {
    LOW: 1,
    NORMAL: 2,
    HIGH: 3,
}

const list = [
    {
        value: type.LOW,
        text: "Baixa",
    },
    {
        value: type.NORMAL,
        text: "Normal",
    },
    {
        value: type.HIGH,
        text: "Alta",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}